import React from 'react';
import UI from "components/UI"
import {FileType} from "../../types/KFileUploadType";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { DataJobTypes } from 'domain/BaseEntity';
import ObjectUtil from 'utils/ObjectUtil';

export interface UIInputProps {
    className?: string;
    id?: string;
    value?: TbComFile;
    valueChanged?: (value: TbComFile) => void;
    
    autoFocus?: boolean;
    setFocus?: boolean;
    //full?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    //className?: string;
    placeholder?: string;
    attrs?: React.InputHTMLAttributes<HTMLInputElement>;
    onKeyEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

function UIInputFile({
                     attrs = {},
                     disabled,
                     id = "file",
                     placeholder,
                     readOnly,
                     setFocus,
                     value = new TbComFile(),
                     valueChanged
                 }: UIInputProps) {
    const RAONKUPLOAD = window["RAONKUPLOAD"];
    const [inputValue, setInputValue] = React.useState<TbComFile>(value);

    const onUploadCompleteHandle = function (uploadId: string) {
        const fileInfo = RAONKUPLOAD.GetListInfo("array", uploadId);
        console.log("uploaded file info", fileInfo);

        const tbComFileMapngDetailList: TbComFileMapngDetail[] = [];
        fileInfo.newFile?.forEach((newFile, index) => {
            const tbComFileMapngDetail = observable(new TbComFileMapngDetail());
            tbComFileMapngDetail.set_JOB_TYPES(DataJobTypes.CREATE);
            tbComFileMapngDetail.setFileDetailId(ObjectUtil.undefined);
            tbComFileMapngDetail.setFilePolicy("raonk");
            tbComFileMapngDetail.setFileRpstr("raonk");
            tbComFileMapngDetail.setStrePath("/" + newFile.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/"));
            tbComFileMapngDetail.setStreFileNm(newFile.uploadName);
            tbComFileMapngDetail.setOrginlFileNm(newFile.originalName);
            tbComFileMapngDetail.setFileExtsn(newFile.extension);
            tbComFileMapngDetail.setFileSize(newFile.size);
            tbComFileMapngDetail.setDwldId(ObjectUtil.undefined);
            tbComFileMapngDetail.setSortOrdr(index + 1);
            tbComFileMapngDetailList.push(tbComFileMapngDetail);
        })
        fileInfo.deleteFile?.forEach((delFile) => {
            const tbComFileMapngDetail = new TbComFileMapngDetail();
            tbComFileMapngDetail.set_JOB_TYPES(DataJobTypes.DELETE);
            tbComFileMapngDetail.setFileDetailId(delFile.uniqKey);
            tbComFileMapngDetailList.push(tbComFileMapngDetail);
        });
        if(value) {
            value.tbComFileMapngDetailList = tbComFileMapngDetailList;
        }

        setInputValue(value);
        valueChanged && valueChanged(value)
    }

    const onAfterDeleteFileHandle = (uploadID: string, paramObj: FileType) => {
        onUploadCompleteHandle(uploadID);
    };

    const onAfterAddFileHandle = function (uploadID: string, paramObj: FileType) {
        RAONKUPLOAD.Transfer(uploadID);
    }

    return (
        <div className='filebox w100p'>
            <UI.FileUpload
                onAfterAddFile={onAfterAddFileHandle}
                onUploadComplete={onUploadCompleteHandle}
                onAfterDeleteFile={onAfterDeleteFileHandle}
                className={'w100p'}
                attrs={{
                    Width:"100%",
                    Height: "50px",
                    SimpleUIMode: {
                        Use: '1',
                        Mode: 'single',
                        EditMode: {
                            VisibleHeader: '1',
                            VisibleIcon: '1',
                            IconList: 'fileAdd,fileSend,deleteAll',
                            VisibleTitle: '1',
                            TitleText: 'UPLOAD'
                        },
                        ViewMode: {
                            VisibleHeader: '1',
                            VisibleIcon: '1',
                            IconList: '',
                            VisibleTitle: '1',
                            TitleText: 'DOWNLOAD'
                        },
                    }
                }}/>
        </div>
    );
}

export default observer(UIInputFile);
